import { Routes } from '@angular/router';
import { ClientLandingComponent } from './pages/client-landing/client-landing.component';
import { EnrollmentComponent } from './pages/enrollment/enrollment.component';

export const routes: Routes = [
    { 
        path: 'continue/:id',
        title: 'Continuation Enrollment',
        component: ClientLandingComponent,
    },
    { 
        path: 'enroll/:id',
        title: 'Enroll',
        component: EnrollmentComponent,
    },
    { 
        path: 'enrollment/:sessionToken/:otpToken',
        title: 'Verify Enrollment',
        component: EnrollmentComponent,
    },
    { 
        path: 'enrollment/:sessionToken',
        title: 'Continue Enrollment',
        component: EnrollmentComponent,
    },
];
